const isZero = (num) => num <= 0;

export default isZero;
